import { LayoutGrid, List } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ProjectsViewToggleProps {
  viewMode: string
  onViewModeChange: (mode: 'list' | 'tile') => void
}

export function ProjectsViewToggle({ viewMode, onViewModeChange }: ProjectsViewToggleProps) {
  return (
    <div className="flex items-center p-1 gap-1 rounded-md border bg-toolbar">
      <Button
        variant={viewMode === 'tile' ? 'secondary' : 'ghost'}
        size="icon"
        className={`rounded ${viewMode === 'tile' ? 'bg-primary text-primary-foreground' : ''}`}
        onClick={() => onViewModeChange('tile')}
        aria-label="Switch to tile view"
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant={viewMode === 'list' ? 'secondary' : 'ghost'}
        size="icon"
        className={`rounded ${viewMode === 'list' ? 'bg-primary text-primary-foreground' : ''}`}
        onClick={() => onViewModeChange('list')}
        aria-label="Switch to list view"
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  )
}
